module.exports = __webpack_public_path__ + "static/img/delete1.8de16d3f.svg";